module.exports = __webpack_public_path__ + "static/media/LG400BiFacial.3021785d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LG400BiFacial.jpg
// module id = 1075
// module chunks = 0